import { BACKEND_URL } from "@/constants";

let mimickingUser: string | undefined = undefined;
export function isMimickingUser() {
  return mimickingUser;
}

export function setMimickingUser(emailAddress: string) {
  mimickingUser = emailAddress;
}

interface WhoamiResponse {
  user: {
    id: number;
    email: string;
    locale: string;
    groups: string[];
  };
}

export async function loadWhoami() {
  const response = await fetch(BACKEND_URL + "/users/whoami", {
    method: "POST",
    credentials: "include",
  });

  if (response.status !== 200) {
    return undefined;
  }

  return response.json() as Promise<WhoamiResponse>;
}

export function resetUserSession() {
  window.location.reload();
}
